import React from "react";
// async component
import PDFSignature from "routes/pdfSignature";
import AddPlaceHolders from "routes/rndPart";
import ThankYou from "routes/thankYou";
import UpLoadHtml from "routes/uploadHtml";

export default [
  {
    path: "/sign/:id",
    component: <PDFSignature />,
  },

  {
    path: "/uploadHtml/:id",
    component: <UpLoadHtml />,
  },

  {
    path: "/signature/complete",
    component: <ThankYou />,
  },
  {
    path: "/placeholder/:id",
    component: <AddPlaceHolders />,
  },
];
